export const moduleSlug = 'engagement'
export const moduleAuth = 'Engagement';

export const children = [
  {
    path: "",
    component: () => import("./pages/CampaignLanding.vue"),
    meta: {
      title: "Create",
      linkTitle: "Create",
      linkIcon: "file-o",
      showInNav: true,
      permission: "Engagement.Create",
    },
  },
  {
    path: "create/announcement",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Annoucement Campaign",
      showInNav: false,
      permission: "Engagement.Create.Announcement",
    },
  },
  {
    path: "create/winback",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Winback Campaign",
      showInNav: false,
      permission: "Engagement.Create.Winback",
    },
  },
  {
    path: "create/scheduled",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Scheduled Campaign",
      showInNav: false,
      permission: "Engagement.Create.Scheduled",
    },
  },
  {
    path: "create/automated",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Automated Campaign",
      showInNav: false,
      permission: "Engagement.Create.Automated",
    },
  },
  {
    path: "create/profile-builder",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Profile Builder Campaign",
      showInNav: false,
      permission: "", // TODO
    },
  },
  {
    path: "create/birthday",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Birthday Campaign",
      showInNav: false,
      permission: "Engagement.Create.Birthday",
    },
  },
  {
    path: "update/:id/birthday",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Update Birthday Campaign",
      showInNav: false,
      permission: "Engagement.Create.Birthday",
    },
  },
  {
    path: "update/:id/anniversary",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Update anniversary Campaign",
      showInNav: false,
      permission: "Engagement.Create.Anniversary",
    },
  },
  {
    path: "create/anniversary",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Anniversary Campaign",
      showInNav: false,
      permission: "Engagement.Create.Anniversary",
    },
  },
  {
    path: "create/quizzes",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Quiz",
      showInNav: false,
      permission: "", // TODO
    },
  },
  {
    path: "create/marketing-automation",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Marketing Automation",
      showInNav: false,
      permission: "Engagement.Create.MarketingAutomation",
    },
  },
  {
    path: "create/A-b/testing",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create A-B testing",
      showInNav: false,
      permission: "", // TODO
    },
  },
  {
    path: "create/warmup",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Create Schedule Warmup",
      showInNav: false,
      permission: "Engagement.Create", // TODO
    },
  },
  {
    path: "update/:id/warmup",
    component: () => import("./components/CreateAnnonce.vue"),
    meta: {
      title: "Update warmup Campaign",
      showInNav: false,
      permission: "Engagement.Create",
    },
  },
  {
    path: "drafts",
    component: () => import("./pages/CampaignDrafts.vue"),
    meta: {
      title: "Drafts",
      linkTitle: "Drafts",
      linkIcon: "files-o",
      showInNav: true,
      permission: "Engagement.Drafts",
    },
  },
  {
    path: "scheduled",
    component: () => import("./pages/CampaignScheduled.vue"),
    meta: {
      title: "Campaign Scheduled",
      linkTitle: "Scheduled",
      linkIcon: "clock-o",
      showInNav: true,
      permission: "Engagement.Scheduled",
    },
  },
 
  // automations 
  {
    path: "automations",
    component: () => import("./pages/CampaignAutomated.vue"),
    props: {
      'selectedModule' : moduleSlug
    },
    meta: {
      title: "Campaign Automations",
      linkTitle: "Automations",
      linkIcon: "plus",
      showInNav: true,
      permission: "Engagement.Automations",
    },
  },
  {
    path: "automation/details/:campaignId",
    component: () => import("./pages/CampaignDetails.vue"),
    meta: {
      title: "Campaign Automation Details",
      showInNav: false,
      modulePage: "automation",
      parent: "automations",
      permission: "Engagement.Automations.Details",
    },
  },
  {
    path: "automations/history/:campaignId",
    component: () => import("./pages/CampaignList.vue"),
    meta: {
      title: "Automation Campaign History",
      showInNav: false,
      permission: "Engagement.Automations.Details.History",
    },
  },
  {
    path: "automations/message-details/:campaignId",
    component: () => import("./pages/AutomationCampaignLogs.vue"),
    meta: {
      title: "Automation Campaign Message Details",
      showInNav: false,
      permission: "Engagement.Automations.Details.Logs",
    },
  },


  // history
  {
    path: "history",
    component: () => import("./pages/CampaignList.vue"),
    meta: {
      title: "Campaign History",
      linkTitle: "History",
      linkIcon: "calendar-o",
      showInNav: true,
      permission: "Engagement.History",
    },
  },
  {
    path: "history/details/:campaignId",
    component: () => import("./pages/CampaignDetails.vue"),
    meta: {
      title: "Campaign Details",
      modulePage: "history",
      showInNav: false,
      permission: "Engagement.History.Details",
    },
  },
  {
    path: "message-details/:campaignId",
    component: () => import("./pages/CampaignLogs.vue"),
    meta: {
      title: "Campaign Message Details",
      showInNav: false,
      permission: "Engagement.History.Details.Logs",
    },
  },

  {
    path: "revenue-impression/:campaignId",
    component: () => import("./pages/RevenueImpression.vue"),
    meta: {
      title: "Campaign Revenue Impression",
      showInNav: false,
      permission: "Engagement.Automations.Details.History",
    },
  },
  {
    path: "revenue-generated/:campaignId",
    component: () => import("./pages/RevenueGenerated.vue"),
    meta: {
      title: "Campaign Revenue Generated",
      showInNav: false,
      permission: "Engagement.History.Details",
      permission: "Engagement.Automations.Details.History",
    },
  },
  {
    path: "revenue-impression/:campaignId",
    component: () => import("./pages/RevenueImpression.vue"),
    meta: {
      title: "Campaign Revenue Impression",
      showInNav: false,
      permission: "Engagement.History.Details",
    },
  },
  {
    path: "exclude-customers/:campaignId",
    component: () => import("./pages/ExcludeCustomersReport.vue"),
    meta: {
      title: "Campaign exclude customers",
      showInNav: false,
      permission: "Engagement.History.Details",
    },
  },
  {
    path: "email-validation",
    component: () => import("./pages/EmailValidation/List.vue"),
    props: { selectedModule : moduleSlug },
    meta: {
      title: "Email Validation",
      showInNav: false,
      permission: "Engagement.Config.EmailValidation.Read",
    },
  },
  {
    path: "email-validation/create",
    component: () => import("./pages/EmailValidation/AddUpdateFile.vue"),
    props: { selectedModule : moduleSlug },
    meta: {
      title: "Create | Email Validation",
      showInNav: false,
      permission: "Engagement.Config.EmailValidation.Write",
    },
  },
  {
    path: "email-validation/update/:id",
    component: () => import("./pages/EmailValidation/AddUpdateFile.vue"),
    props: { selectedModule : moduleSlug },
    meta: {
      title: "Update | Email Validation",
      showInNav: false,
      permission: "Engagement.Config.EmailValidation.Write",
    },
  },
  {
    path: "email-validation/overview/:id",
    component: () => import("./pages/EmailValidation/DetailAnalytics.vue"),
    props: { selectedModule : moduleSlug },
    meta: {
      title: "Update | Email Validation",
      showInNav: false,
      permission: "Engagement.Config.EmailValidation.Write",
    },
  },
  {
    path: 'config/settings',
    component: () => import('@/components/Configuration/Configurations.vue'),
    props: { moduleSlug: moduleSlug },
    meta: {
      title: 'Configurations',
      linkIcon: '',
      showInNav: false,
      brandFlag: 'enableConfigurations',
      permission: "Engagement.Config.Settings",
    }
  },
];

export const quickLinks = [
  {
    name: 'Settings',
    link: `/${moduleSlug}/config/settings`,
    new: true,
    brandFlag: 'enableConfigurations',
    permission: "Engagement.Config.Settings",
  },
  {
    name: 'Email Validation',
    link: `/${moduleSlug}/email-validation`,
    new: true,
    permission: 'Engagement.Config.EmailValidation.Read',
  }
];
